/**
 * The client's written sign-off for Contact News, as the settings row holds it
 * (CRE-20 / LPR-27 / MOD-13). Read strictly: only an explicit `true` is on.
 */
export type NewsSearchApproval = {
  approved: boolean
  approvedBy: string | null
  approvedAt: string | null
  note: string
}

export function readNewsSearchApproval(value: unknown): NewsSearchApproval {
  const raw = (value && typeof value === 'object' ? value : {}) as Partial<NewsSearchApproval>
  return {
    approved: raw.approved === true,
    approvedBy: typeof raw.approvedBy === 'string' ? raw.approvedBy : null,
    approvedAt: typeof raw.approvedAt === 'string' ? raw.approvedAt : null,
    note: typeof raw.note === 'string' ? raw.note : '',
  }
}

export function formatWhen(iso: string | null): string {
  if (!iso) return ''
  const when = new Date(iso)
  return Number.isNaN(when.getTime()) ? '' : when.toLocaleDateString('en-US', { dateStyle: 'medium' })
}

/** One line for the Integrations table: is news actually allowed to run? */
export function newsSignOffSummary(value: unknown): string {
  const approval = readNewsSearchApproval(value)
  if (!approval.approved) return 'News search: Off — awaiting the client’s written sign-off.'
  const when = formatWhen(approval.approvedAt)
  return `News search: On — sign-off recorded by ${approval.approvedBy ?? 'an admin'}${when ? ` on ${when}` : ''}.`
}

